import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SignIn from "./frontend/SignIn/SignIn";
import { UserProvider } from "./backend/HelperFunctions/getCurrentUser";
import RecruitmentFrom from "./frontend/HomeScreen/components/RecruitmentForm";
import { auth } from "../src/backend/firebaseConfig";

const PING_INTERVAL = 300000; // Every 5 minutes (300,000 ms)

const keepServerAwake = () => {
  fetch("https://rosemount-explore.onrender.com/api/status")
    .then(() => {
      // console.log("Pinged Render API to keep it awake")
    })
    .catch(() => {
      //  console.log("Ping failed, but will retry in 5 mins")
    });
};

const ProtectedRoute = ({ user, children }) => {
  if (!user) {
    // console.log("No user found. Redirecting to Sign-In...");
    return <Navigate to="/" replace />;
  }

  return children;
};
function App  ()  {
  const [user, setUser] = useState(null); // Track the authenticated user
  const [loading, setLoading] = useState(true); // Show loading until Firebase restores the session

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user); // Set the user in state
      setLoading(false); // Loading is complete once auth state is determined
    });

    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  // useEffect(() => {
  //   keepServerAwake(); // Ping once when the component mounts
  //   const interval = setInterval(keepServerAwake, PING_INTERVAL);
  //   return () => clearInterval(interval); // Cleanup interval on unmount
  // }, []);

  if (loading) {
    // Show a loading indicator while Firebase initializes
    return <div>Loading...</div>;
  }

  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute user={user}>
                <RecruitmentFrom />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Application"
            element={
              <ProtectedRoute user={user}>
                <RecruitmentFrom />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </UserProvider>
  );
};

export default App;
